jQuery(document).ready(function() {
  /* Auto-focus search input if on search page */
  var search_input = jQuery('#search-form input[type="text"]');
  if (search_input.length > 0) {
    search_input.focus();
  }

  /* Expand mobile menu button */
  var shell = jQuery('#mobile-fly-icon');
  shell.click(function() {
    shell.find('.first-icon').toggleClass('rotate-first');
    shell.find('.second-icon').toggleClass('remove-second');
    shell.find('.third-icon').toggleClass('rotate-third');
  });

  if (typeof sleepless_options !== 'undefined') {
    /* Product Description Page (Multiple Alternate Images) */
    var active_image = {
      $shell: null,
      value: null
    };
    jQuery('.list-alt-image .alt-image__shell').each(function() {
      var variant_image = {
        $shell: jQuery(this),
        value: jQuery(this).data('imageId')
      };
      if (active_image.value === null) {
        active_image = {
          $shell: jQuery(this),
          value: jQuery(this).data('imageId')
        };
        set_active_image(active_image);
      }
      variant_image.$shell.on('click', set_active_image.bind(this, variant_image));
      variant_image.$shell.on('mouseover', set_featured_active_image.bind(this, variant_image));
      variant_image.$shell.on('mouseleave', set_featured_active_image.bind(this, active_image));

      // -- Functions -- //
      function set_active_image(my_variant) {
        clear_active_image();
        // add orange border to selected thumbnail
        my_variant.$shell.addClass('alt-image__shell--active');
        active_image.$shell = my_variant.$shell;
        active_image.value = my_variant.value;
        // display selected thumbnail as featured image
        set_featured_active_image(my_variant);
      }

      function clear_active_image() {
        jQuery('.list-alt-image .alt-image__shell').each(function() {
          jQuery(this).removeClass('alt-image__shell--active');
        });
      }

      function set_featured_active_image(my_variant) {
        jQuery('#featured-product-image .featured-product-image').each(function() {
          var $featured_image = jQuery(this);
          var image_id = $featured_image.data('imageId');

          if (my_variant.value !== image_id) {
            jQuery(this).css('display', 'none');
          } else {
            jQuery(this).css('display', 'block');
          }
        });
      }
    });

    /* Product Description Page (Multiple Variants Dropdown) */
    var list_options = sleepless_options.options;
    // map option position to its name
    var map_position_to_name = {};
    var map_name_to_position = {};
    for (var i = 0; i < list_options.length; ++i) {
      map_position_to_name[list_options[i].position] = list_options[i].name;
      map_name_to_position[list_options[i].name] = list_options[i].position;
    }
    // determine which option number is being used for the swatch
    var swatch_variant_option_number = null;
    for (var i = 0; i < list_options.length; ++i) {
      if (sleepless_options.swatch_variant === list_options[i].name) {
        swatch_variant_option_number = list_options[i].position;
      }
    }
    // select correct product SKU on dropdown change
    var selected_sku = {};
    jQuery('.option-wrapper__row select.option-wrapper-select').each(function() {
      var $option_select = jQuery(this);
      var name = $option_select.attr('name');

      // update selected product sku on change
      $option_select.change(function() {
        var changed_val = $option_select.val();
        update_selected_sku(name, changed_val);
      });

      // initialize selected product sku
      var initial_val = $option_select.val();
      selected_sku[name] = initial_val;
    });

    jQuery('.option-wrapper__row select.option-wrapper-select option').each(function() {
      var $option = jQuery(this);
      var value = $option.attr('value');
      var option_type = $option.parent().attr('name');
      console.log("available :: "+get_availability(option_type, value));
      var not_available = (get_availability(option_type, value) === false);
      /*
      if (not_available === true) {
        $option.attr('disabled', 'true');
      }
      */
    });

    function get_availability(option_type, value) {
      var _return = false;
      var option_position = map_name_to_position[option_type];
      var list_info = sleepless_options.info;
      for (var i = 0; i < list_info.length; ++i) {
        var info = list_info[i];
        if (info['option' + option_position] === value) {
          _return = _return || (info.inventory_quantity > 0);
        }
      }
      return _return;
    }

    /* Product Description Page (Variants Logic) */
    var $list_variant = $('.list-variant');
    if ($list_variant.length > 0) {
      var $dropdown_options = jQuery('select.option-wrapper-select[name="' + sleepless_options.swatch_variant + '"]');
      var active = {
        $shell: null,
        value: null
      };

      // on page load
      var url_params = new URLSearchParams(window.location.search);
      var q_variant = url_params.get('variant');

      if (q_variant !== null) {
        // initialize actual product selector
        var exact_product_info = null;
        for (var i = 0; i < sleepless_options.info.length; ++i) {
          if (sleepless_options.info[i].id == q_variant) {
            exact_product_info = sleepless_options.info[i].options;
          }
        }
        for (var i = 0; i < exact_product_info.length; ++i) {
          var exact_name = null;
          var exact_value = exact_product_info[i];
          for (var j = 0; j < list_options.length; ++j) {
            var haystack = list_options[j].values;
            if (haystack.indexOf(exact_value) !== -1) {
              exact_name = list_options[j].name;
              break;
            }
          }
          selected_sku[exact_name] = exact_value;
        }

        // initialize dropdown options
        jQuery('.option-wrapper__row select.option-wrapper-select').each(function() {
          var $option_select = jQuery(this);
          var name = $option_select.attr('name');

          $option_select.val(selected_sku[name]);
        });
      }

      // on new dropdown selection
      $dropdown_options.change(function() {
        clear_active_variant();
        var new_selection = {
          $shell: $('.variant__shell[data-variant-option' + swatch_variant_option_number + '="' + $dropdown_options.val() + '"]'),
          value: $dropdown_options.val()
        };
        set_active_variant(new_selection);
      });

      // on variant thumbnail click
      $list_variant.find('.variant__shell').each(function(index, _el) {
        var variant = {
          $shell: jQuery(_el),
          value: jQuery(_el).data('variantOption' + swatch_variant_option_number),
        };

        // if no active selection, default to first variant
        if ((active.$shell === null) && (index === 0)) {
          var default_variant = {
            $shell: jQuery('.variant__shell[data-variant-option' + swatch_variant_option_number + '="' + selected_sku[sleepless_options.swatch_variant] + '"]'),
            value: convert_id_to_swatch_option(q_variant),
          };
          // select variant on swatch
          if (default_variant.value === null) {
            set_active_variant(variant);
          } else {
            set_active_variant(default_variant);
          }
        }

        variant.$shell.on('click', set_active_variant.bind(this, variant));
        variant.$shell.on('mouseover', show_featured_image.bind(this, variant));
        variant.$shell.on('mouseleave', show_featured_image.bind(this, active));
      });

      // --- Functions ---
      function clear_active_variant() {
        $list_variant.find('.variant__shell--active').each(function() {
          $(this).removeClass('variant__shell--active');
        });
      }

      function set_active_variant(variant_obj) {
        // clear previous
        clear_active_variant();
        // set this variant as active
        active.$shell = variant_obj.$shell;
        active.value = variant_obj.value;
        // style the selected choice
        active.$shell.addClass('variant__shell--active');
        // select variant in dropdown
        $dropdown_options.val(active.value);
        // update the add to cart button, in case not available
        var option_name = sleepless_options.swatch_variant;
        var is_available = get_availability(option_name, variant_obj.value);
        if (is_available === true) {
          enable_add_to_cart();
        } else {
          disable_add_to_cart();
        }
        // show as featured image
        clear_featured_image();
        show_featured_image(active);
        // select product SKU
        update_selected_sku($dropdown_options.attr('name'), $dropdown_options.val());
      }

      function clear_featured_image() {
        $('#featured-product-image img[data-variant-id]').each(function() {
          $(this).css('display', 'none');
        });
      }

      function show_featured_image(variant) {
        clear_featured_image();
        var featured_image = $('#featured-product-image img[data-variant-option' + swatch_variant_option_number + '="' + variant.value + '"]');
        featured_image.css('display', 'block');
      }

      function convert_id_to_swatch_option(id) {
        var _return = null;
        var list_info = sleepless_options.info;
        for (var i = 0; i < list_info.length; ++i) {
          if (list_info[i].id == id) {
            _return = list_info[i]['option' + swatch_variant_option_number];
          }
        }
        return _return;
      }

      function update_selected_sku(name, new_val) {
        selected_sku[name] = new_val;

        // generate the variant options signature
        var needle = [];
        for (var option in selected_sku) {
          if (selected_sku[option] !== null) {
            needle.push(selected_sku[option]);
          }
        }
        select_product_sku(needle, sleepless_options.info);
      }

      function select_product_sku(needle, info) {
        var product_info = _find_sku(needle, info);
        if (product_info) {
          if (product_info.available == true) {
            jQuery('#actual-product-selector').val(product_info.id);
            enable_add_to_cart();
          } else {
            disable_add_to_cart();
          }
        }
      }

      function disable_add_to_cart() {
        var $add_cart_btn = jQuery('.product-input-div .add-cart-button');
        $add_cart_btn.addClass('add-cart-button--disabled');
        $add_cart_btn.attr('disabled', 'true');
        $add_cart_btn.text('SOLD OUT');
      }

      function enable_add_to_cart() {
        var $add_cart_btn = jQuery('.product-input-div .add-cart-button');
        $add_cart_btn.removeClass('add-cart-button--disabled');
        $add_cart_btn.removeAttr('disabled');
        $add_cart_btn.text('ADD TO CART');
      }

      function _find_sku(needle, info) {
        var _return = null;

        // look for signature in shopify product info
        for (var i = 0; i < info.length; ++i) {
          var found = _array_equals(needle, info[i].options);
          if (found === true) {
            _return = info[i];
          }
        }
        return _return;
      }

      function _array_equals(array1, array2) {
        return array1.length === array2.length && array1.every(function(value, index) {
          return value === array2[index]
        });
      }

    }
  }
});
